import React, { useEffect, useState } from "react";
import { addUser, getUserList } from "../../api/api";
import { toast } from "react-toastify";

const Adduser = ({ setUsers, users }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    signup_from: "admin",
  });

  const adduser = async () => {
    try {
      let response = await addUser(formData);
      if (response) {
        setFormData({
          name: "",
          email: "",
          password: "",
          signup_from: "admin",
        });
        userlist();
      }
    } catch (e) {
      toast.error(e);
    }
  };

  useEffect(() => {
    userlist();
  }, []);

  const userlist = async () => {
    try {
      const response = await getUserList();
      if (response) {
        console.log(response);

        setUsers(response.data);
      }
    } catch (e) {
      toast.error(e);
    }
  };
  console.log(users);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddUser = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email) return;

    const newUser = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
      signup_from: "admin",
    };

    setUsers([...users, newUser]);
    setFormData({ name: "", email: "", password: "" });
  };

  const handleDeleteUser = (id) => {
    setUsers(users.filter((user) => user.id !== id));
  };

  return (
    <div className="p-5 max-w-full mx-auto ml-10">
      <h2 className="text-2xl font-bold mb-4 text-left">Add New User</h2>
      <div className="flex flex-col w-full gap-5">
        <div className="mb-5 flex flex-col gap-3 w-1/2">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none"
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none"
          />
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Password"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none"
          />

          <button
            onClick={() => adduser()}
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Add User
          </button>
        </div>
        <div className="w-1/2 ">
          <h3 className="text-2xl font-semibold mb-3 text-left">User List</h3>
          <ul className="list-none p-0 overflow-auto h-[40vh]">
            {users.map((user) => (
              <li
                key={user.id}
                className="flex items-center justify-between mb-3 border border-gray-200 rounded-lg px-3 py-2"
              >
                <span className="text-gray-800">
                  {user.username} ({user.email})
                </span>
                {/* <button
                  onClick={() => handleDeleteUser(user.id)}
                  className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                >
                  Delete
                </button> */}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Adduser;
